export function deepMerge<T extends object>(prev: T, next: Partial<T>): T {
  if (typeof prev !== 'object' || prev === null) {
    return next as T
  }
  if (typeof next !== 'object' || next === null) {
    return prev
  }

  const result = Array.isArray(prev) ? ([...prev] as unknown as T) : { ...prev }

  ;(Object.keys(next) as (keyof T)[]).forEach((key) => {
    const prevVal = prev[key]
    const nextVal = next[key]
    if (
      prevVal &&
      nextVal &&
      typeof prevVal === 'object' &&
      typeof nextVal === 'object' &&
      !Array.isArray(prevVal) &&
      !Array.isArray(nextVal)
    ) {
      ;(result as T)[key] = deepMerge(prevVal, nextVal)
    } else if (nextVal !== undefined) {
      ;(result as T)[key] = nextVal as T[typeof key]
    }
  })
  ;(Object.keys(prev) as (keyof T)[]).forEach((key) => {
    if (!(key in next)) {
      ;(result as T)[key] = prev[key]
    }
  })

  return result
}
